/** SearchInput — magnifier + text input. Height 36, pad-left 34, radius r2. */
import React from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { colors, fontFamily, fontSize, radii } from '../theme';
import { Search } from '../icons';

type Props = { value: string; onChange: (v: string) => void; placeholder?: string; width?: number; mono?: boolean; height?: number };

export default function SearchInput({ value, onChange, placeholder, width, mono, height = 36 }: Props) {
  return (
    <View style={[styles.wrap, width ? { maxWidth: width } : null]}>
      <View style={styles.icon}><Search size={mono ? 14 : 15} color={colors.ink4} /></View>
      <TextInput
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        placeholderTextColor={colors.ink4 as any}
        style={[styles.input, { height, fontFamily: mono ? fontFamily.mono : fontFamily.sans, fontSize: mono ? fontSize.sm : fontSize.md } as any]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { position: 'relative', flex: 1 },
  icon: { position: 'absolute', left: 11, top: 0, bottom: 0, justifyContent: 'center', zIndex: 1 } as any,
  input: {
    width: '100%',
    paddingLeft: 34,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: colors.line,
    backgroundColor: colors.card,
    borderRadius: radii.r2,
    color: colors.ink as any,
    outlineStyle: 'none',
  } as any,
});
